(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('#notifyMeButton') : null;
    if (!trigger) return;
    const variantId = trigger.closest('product-form-component')?.querySelector('input[name="id"]')?.value;
    if (!variantId) return;
    let observer;
    let timeout;
    const synchronize = () => {
      const select = document.getElementById('notifyVariantSelect');
      if (!(select instanceof HTMLSelectElement) || !select.getClientRects().length) return;
      if (![...select.options].some((option) => option.value === variantId)) return;
      observer.disconnect();
      clearTimeout(timeout);
      select.value = variantId;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    };
    observer = new MutationObserver(synchronize);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
    timeout = setTimeout(() => observer.disconnect(), 5000);
    requestAnimationFrame(synchronize);
  }, true);
  } catch(e) { console.error(e); }
})();

})();
